// extracted by mini-css-extract-plugin
module.exports = {"hideInputNumber":"styles_hideInputNumber__2EQqS"};